<template>
  <el-config-provider :locale="currentLocale" :size="elSize">
    <router-view />
  </el-config-provider>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { ElConfigProvider } from 'element-plus';
import vi from 'element-plus/es/locale/lang/vi';
import en from 'element-plus/es/locale/lang/en';

const { locale } = useI18n();

const currentLocale = computed(() => (locale.value === 'vi' ? vi : en));
const elSize = 'default';
</script>

<style>
/* Global resets and base styles */
:root {
  --tts-color-primary: #409eff;
  --tts-color-success: #67c23a;
  --tts-color-warning: #e6a23c;
  --tts-color-danger: #f56c6c;
  --tts-color-info: #909399;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
}

#app {
  height: 100%;
}
</style>
